import React from "react";
import "./styles.scss";
import { Modal, ProgressBar } from "react-bootstrap";
import { indexMedia, createMedium, deleteMedium } from "../../../api/media";
import { log_error } from "../../../api";
import _ from "lodash";
import FullPageSpinner from "../../FullPageSpinner";
import { object_url, getCurrentUser } from "../../../api/helper";
import { uploadMedia } from "../../../api/aws_s3";
import MediaTag from "../../App/shared/MediaTag";
import { isSizeBetweenOneAndTenMB, checkCoverSizeAndRatio } from "../viewsHelper";

export default class ImagePicker extends React.Component {
  state = {
    show: false,
    images: null,
    selectedImage: null,
    progress: null,
    errorMessage: "",
  };
  handleClick = (e) =>
    this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidMount = () =>
    document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClick);
  handleClose = () => this.setState({ show: false, errorMessage: "" });
  handleShow = () => {
    this.updateList();
    this.setState({ show: true });
  };
  onSelectImage = (medium, type = "") => {
    this.setState({ selectedImage: medium });
    if (type === "default") {
      this.setState({ errorMessage: "" });
    }
  };
  updateList = async () => {
    try {
      let {
        data: { media },
      } = await indexMedia({ filter: { type: "Image" } });
      this.setState({ images: media });
    } catch (error) {
      console.log(log_error(error));
    }
  };
  uploadImage = async () => {
    try {
      const file = this.fileInput.current.files[0];
      if (!file) throw Error("Select a file");
      if (
        this.props.checkCoverSizeValidation &&
        ["artist", "label"].includes(getCurrentUser().user_type)
      ) {
        if (!isSizeBetweenOneAndTenMB(file)) {
          return this.setState({
            errorMessage:
              "Oops! It looks like your artwork is too big or too small. Please upload artwork that has a file size between 1MB and 10MB.",
          });
        }
        if (await checkCoverSizeAndRatio(file)) {
          return this.setState({
            errorMessage:
              "Be sure that your cover artwork is square, and a minimum width x height of 1400 x 1400 pixels, up to 4000 x 4000 pixels.",
          });
        }
      }
      this.setState({ errorMessage: "" });
      let s3_object_key = object_url();
      await uploadMedia(
        file,
        file.type,
        getCurrentUser().id,
        s3_object_key,
        (e) => {
          this.setState({
            progress: (e.loaded * 100) / e.total,
          });
        }
      );
      let {
        data: { medium },
      } = await createMedium({
        media: {
          s3_object_key,
          type: "Image",
        },
      });
      this.onSelectImage(medium);
      this.updateList();
    } catch (error) {
      console.log(log_error(error));
    } finally {
      this.setState({ progress: null });
    }
  };
  onSubmit = () => {
    if (_.isNull(this.state.selectedImage)) return;
    this.props.onSubmit(this.state.selectedImage);
    this.handleClose();
  };
  onDeleteMedium = async (id) => {
    try {
      await deleteMedium(id);
      this.updateList();
    } catch (error) {}
  };
  fileInput = React.createRef();
  hocWrapper = React.createRef();

  handleImageSelect = (imageSize, img, type) => () => {
    if(imageSize < 1) return;
    this.onSelectImage(img, type);
  }

  render() {
    const requiredSize = "For your album/single cover, your cover art file should be square, 1MB to 10MB maximum filesize, and a minimum width x height of 1400 x 1400 pixels up to 4000 x 4000 pixels at 72dpi (web/screen resolution)."
    const acceptedFormat = "JPG/JPEG, PNG, BMP, TIFF/TIF, Webp, or GIF."
    return (
      <>
        <div
          ref={this.hocWrapper}
          className={`${this.props.className} hor_click`}
        >
          {this.props.children}
        </div>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Body>
            <Modal.Title>Pick/Upload an image</Modal.Title>
            <div className="d-flex list">
              {_.isNull(this.state.images) ? (
                <FullPageSpinner />
              ) : this.state.images.length ? (
                this.state.images.map((img) => {
                  const {size} = img;
                  const imageSize = size / 1048576;
                  return(
                    <div>
                  <MediaTag
                    medium={img}
                    className={`img-thumbnail ${
                      this.state.selectedImage &&
                      this.state.selectedImage.id === img.id &&
                      "selected"
                    }
                    ${
                      imageSize < 1 && "invalid-image"
                    }
                    `}
                    onClick={this.handleImageSelect(imageSize, img, "default")}
                  />
                      {imageSize < 1 && <div className="invalid-image-text">Too small! File should 1MB+</div>}
                  </div>
                )})
              ) : (
                <p>You have no uploaded images</p>
              )}
            </div>
            <div className="row mt-3 mb-3">
              <div className="col-50 pr-0">
                <div className="form-group">
                  <input
                    type="file"
                    className="form-control-file"
                    onChange={this.uploadImage}
                    ref={this.fileInput}
                  />
                </div>
                <span className="required_txt">
                  <b>Required Size: </b>{requiredSize} <br/><br/>
                  <b>Accepted Filetypes: </b>{acceptedFormat} <br/>
                </span>
                {!_.isNull(this.state.progress) && (
                  <ProgressBar now={this.state.progress} />
                )}
                {this.state.errorMessage && (
                  <div className="alert alert-danger m-0" role="alert">
                    {this.state.errorMessage}
                  </div>
                )}
              </div>
              <div className="col-50">
                <div
                  id="preview"
                  className={_.isNull(this.state.selectedImage) && "no-img"}
                >
                  {_.isNull(this.state.selectedImage) ? (
                    <h4>
                      {this.state.progress === 100 ? (
                        <FullPageSpinner />
                      ) : (
                        "Preview"
                      )}
                    </h4>
                  ) : (
                    <img
                      className="img-thumbnail img-box-fit"
                      src={this.state.selectedImage.url}
                      alt={this.state.selectedImage.title}
                    />
                  )}
                </div>
              </div>
            </div>
            <Modal.Footer className="mt-2">
              <button className="btn" onClick={this.handleClose}>
                Cancel
              </button>
              <button
                className="btn btn-success"
                disabled={
                  _.isNull(this.state.selectedImage) || this.state.errorMessage
                }
                onClick={this.onSubmit}
              >
                Select
              </button>
            </Modal.Footer>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
